import React from 'react';
import { Card, Title, Text, Stack } from '@mantine/core';

const ImprintPage: React.FC = () => {
  return (
    <Stack gap="md">
      <Title order={2}>Impressum</Title>
      
      <Card withBorder p="md">
        <Stack gap="md">
          <Title order={4}>Angaben gemäß § 5 TMG</Title>
          
          <Text>
            <strong>Galek GmbH</strong><br />
            Am Brunnenbichl 2<br />
            82398 Polling
          </Text>
          
          <Title order={4}>Vertreten durch:</Title>
          <Text>
            Prof. Dr. Marek Galek & Philip Galek
          </Text>
          
          <Title order={4}>Kontakt:</Title>
          <Text>
            Telefon: 0179-1183141<br />
            E-Mail: <a href="mailto:office@timbertrack.de">office@timbertrack.de</a>
          </Text>
          
          <Title order={4}>Webdesign:</Title>
          <Text>
            frazo.de
          </Text>
        </Stack>
      </Card>
    </Stack>
  );
};

export default ImprintPage;
